import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store/index'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/messages',
      name: 'messages',
      component: () => import('./views/messages/Messages.vue'),
      meta: {
        action: [],
        requiresAuth: true,
        roles: ['partner', 'employee', 'client', 'provider']
      }
    },
    {
      path: '/admin-messages/:id',
      name: 'adminMessages',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/messages/AdminMessages.vue'),
      meta: {
        action: [],
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/complaints',
      name: 'complaints',
      component: () => import('./views/complaints/Complaints.vue'),
      meta: {
        action: [],
        requiresAuth: true,
        roles: ['partner', 'employee', 'client', 'provider']
      }
    },
    {
      path: '/admin-complaints/:id',
      name: 'adminComplaints',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/complaints/AdminComplaints.vue'),
      meta: {
        action: [],
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/my-account',
      name: 'viewuseraccount',
      component: () => import('./views/my_account/User.vue'),
      meta: {
        action: [],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import('./views/contacts/Contacts.vue'),
      meta: {
        action: ['view contacts list', 'view only my contacts'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/contacts/create',
      name: 'addcontact',
      component: () => import('./views/contacts/AddContact.vue'),
      meta: {
        action: ['create contact'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/contacts/:id',
      name: 'viewcontact',
      component: () => import('./views/contacts/ViewContact.vue'),
      meta: {
        action: ['view contact', 'view only my contacts'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/contacts/:id/edit',
      name: 'editcontact',
      component: () => import('./views/contacts/EditContact.vue'),
      meta: {
        action: ['update contact', 'update only my contacts'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/clients',
      name: 'clients',
      component: () => import('./views/clients/Clients.vue'),
      meta: {
        action: ['view clients list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/clients/create',
      name: 'addclient',
      component: () => import('./views/clients/AddClient.vue'),
      meta: {
        action: ['create client'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/clients/:id',
      name: 'viewclient',
      component: () => import('./views/clients/ViewClient.vue'),
      meta: {
        action: ['view client'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/clients/:id/edit',
      name: 'editclient',
      component: () => import('./views/clients/EditClient.vue'),
      meta: {
        action: ['update client'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/employees',
      name: 'employees',
      component: () => import('./views/employees/Employees.vue'),
      meta: {
        action: ['view employees list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/employees/create',
      name: 'addemployee',
      component: () => import('./views/employees/AddEmployees.vue'),
      meta: {
        action: ['create employee'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/employees/:id',
      name: 'viewemployee',
      component: () => import('./views/employees/ViewEmployee.vue'),
      meta: {
        action: ['view employee'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/employees/:id/edit',
      name: 'editemployee',
      component: () => import('./views/employees/EditEmployee.vue'),
      meta: {
        action: ['update employee'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/partners',
      name: 'partners',
      component: () => import('./views/partners/Partners.vue'),
      meta: {
        action: ['view partners list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/partners/create',
      name: 'addpartner',
      component: () => import('./views/partners/AddPartner.vue'),
      meta: {
        action: ['create partner'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/partners/:id',
      name: 'viewpartner',
      component: () => import('./views/partners/ViewPartner.vue'),
      meta: {
        action: ['view partner'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/partners/:id/edit',
      name: 'editpartner',
      component: () => import('./views/partners/EditPartner.vue'),
      meta: {
        action: ['update partner'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/categories',
      name: 'categories',
      component: () => import('./views/nivel1/Nivel1.vue'),
      meta: {
        action: ['view nivel1 list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/categories/create',
      name: 'addcategories',
      component: () => import('./views/nivel1/AddNivel1.vue'),
      meta: {
        action: ['create nivel1'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/categories/:id',
      name: 'viewcategory',
      component: () => import('./views/nivel1/ViewNivel1.vue'),
      meta: {
        action: ['view nivel1'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/categories/:id/edit',
      name: 'editcategory',
      component: () => import('./views/nivel1/EditNivel1.vue'),
      meta: {
        action: ['update nivel1'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/subcategories',
      name: 'subcategories',
      component: () => import('./views/nivel2/Nivel2.vue'),
      meta: {
        action: ['view nivel2 list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/subcategories/create',
      name: 'addsubcategories',
      component: () => import('./views/nivel2/AddNivel2.vue'),
      meta: {
        action: ['create nivel2'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/subcategories/:id',
      name: 'viewsubcategory',
      component: () => import('./views/nivel2/ViewNivel2.vue'),
      meta: {
        action: ['view nivel2'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/subcategories/:id/edit',
      name: 'editsubcategory',
      component: () => import('./views/nivel2/EditNivel2.vue'),
      meta: {
        action: ['update nivel2'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/subtypes',
      name: 'subtypes',
      component: () => import('./views/nivel3/Nivel3.vue'),
      meta: {
        action: ['view nivel3 list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/subtypes/create',
      name: 'addsubtype',
      component: () => import('./views/nivel3/AddNivel3.vue'),
      meta: {
        action: ['create nivel3'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/subtypes/:id',
      name: 'viewsubtype',
      component: () => import('./views/nivel3/ViewNivel3.vue'),
      meta: {
        action: ['view nivel3'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/subtypes/:id/edit',
      name: 'editsubtype',
      component: () => import('./views/nivel3/EditNivel3.vue'),
      meta: {
        action: ['update nivel3'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/products',
      name: 'products',
      component: () => import('./views/products/Products.vue'),
      meta: {
        action: ['view products list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/products/create',
      name: 'addproduct',
      component: () => import('./views/products/AddProduct.vue'),
      meta: {
        action: ['create product'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/products/:id',
      name: 'viewproduct',
      component: () => import('./views/products/ViewProduct.vue'),
      meta: {
        action: ['view product'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/products/:id/edit',
      name: 'editproduct',
      component: () => import('./views/products/EditProduct.vue'),
      meta: {
        action: ['update product'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/providers',
      name: 'providers',
      component: () => import('./views/providers/Providers.vue'),
      meta: {
        action: ['view providers list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/providers/create',
      name: 'addprovider',
      component: () => import('./views/providers/AddProvider.vue'),
      meta: {
        action: ['create provider'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/providers/:id',
      name: 'viewprovider',
      component: () => import('./views/providers/ViewProvider.vue'),
      meta: {
        action: ['view provider'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/providers/:id/edit',
      name: 'editprovider',
      component: () => import('./views/providers/EditProvider.vue'),
      meta: {
        action: ['update provider'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('./views/services/Services.vue'),
      meta: {
        action: ['view services list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/services/create',
      name: 'addservice',
      component: () => import('./views/services/AddService.vue'),
      meta: {
        action: ['create service'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/services/:id',
      name: 'viewservice',
      component: () => import('./views/services/ViewService.vue'),
      meta: {
        action: ['view service'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/services/:id/edit',
      name: 'editservice',
      component: () => import('./views/services/EditService.vue'),
      meta: {
        action: ['update service'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/post-sale-services',
      name: 'postsaleservices',
      component: () => import('./views/postServices/PostServices.vue'),
      meta: {
        action: ['view services-ps list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/post-sale-services/create',
      name: 'addpostsaleservice',
      component: () => import('./views/postServices/AddPostService.vue'),
      meta: {
        action: ['create service-ps'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/post-sale-services/:id',
      name: 'viewpostsaleservice',
      component: () => import('./views/postServices/ViewPostService.vue'),
      meta: {
        action: ['view service-ps'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/post-sale-services/:id/edit',
      name: 'editpostsaleservice',
      component: () => import('./views/postServices/EditPostService.vue'),
      meta: {
        action: ['update service-ps'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/offers',
      name: 'offers',
      component: () => import('./views/offers/Offers.vue'),
      meta: {
        action: ['view offers list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/offers/create',
      name: 'createoffer',
      component: () => import('./views/offers/CreateOffer.vue'),
      meta: {
        action: ['create offer'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/offers/:id/edit',
      name: 'editoffer',
      component: () => import('./views/offers/EditOffer.vue'),
      meta: {
        action: ['update offer'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/offers/:id/clone',
      name: 'cloneOffer',
      component: () => import('./views/offers/CloneOffer.vue'),
      meta: {
        action: ['create offer'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/offers/:id/view',
      name: 'viewoffer',
      component: () => import('./views/offers/ViewOffer.vue'),
      meta: {
        action: ['view offer'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/test',
      name: 'tests',
      component: () => import('./views/Test.vue'),
      meta: {
        action: [],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/notification-settings',
      name: 'notificationsettings',
      component: () => import('./views/alertSettings/Settings.vue'),
      meta: {
        action: [],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/counties',
      name: 'counties',
      component: () => import('./views/counties/Counties.vue'),
      meta: {
        action: ['view counties list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/counties/create',
      name: 'createcounty',
      component: () => import('./views/counties/AddCounty.vue'),
      meta: {
        action: ['create county'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/counties/edit',
      name: 'editcounty',
      component: () => import('./views/counties/EditCounty.vue'),
      meta: {
        action: ['update county'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/cities',
      name: 'cities',
      component: () => import('./views/cities/Cities.vue'),
      meta: {
        action: ['view cities list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/cities/create',
      name: 'createcity',
      component: () => import('./views/cities/AddCity.vue'),
      meta: {
        action: ['create city'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/cities/:id/edit',
      name: 'editcity',
      component: () => import('./views/cities/EditCity.vue'),
      meta: {
        action: ['update city'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/offer-templates',
      name: 'offer-templates',
      component: () => import('./views/offer-templates/List.vue'),
      meta: {
        action: ['view offers list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/offer-emails',
      name: 'offer-emails',
      component: () => import('./views/offers/EmailOffer.vue'),
      meta: {
        action: ['view offers list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/offer-templates/create',
      name: 'add-offer-template',
      component: () => import('./views/offer-templates/Create.vue'),
      meta: {
        action: ['create offer'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/offer-templates/:id',
      name: 'view-offer-template',
      component: () => import('./views/offer-templates/View.vue'),
      meta: {
        action: ['view offer'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/offer-templates/:id/edit',
      name: 'edit-offer-template',
      component: () => import('./views/offer-templates/Edit.vue'),
      meta: {
        action: ['update offer'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/service/works',
      name: 'works',
      component: () => import('./views/service/Works.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admins',
      name: 'admins',
      component: () => import('./views/admins/Admin.vue'),
      meta: {
        action: ['view admins list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/service/calendar',
      name: 'calendar',
      component: () => import('./views/service/Calendar.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admins/create',
      name: 'addadmin',
      component: () => import('./views/admins/AddAdmin.vue'),
      meta: {
        action: ['create admin'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/service/vtp',
      name: 'servicevtp',
      component: () => import('./views/service/Vtp.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/service/pif',
      name: 'servicepif',
      component: () => import('./views/pif/Pif.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/service/pif/edit/:id',
      name: 'editpifservice',
      component: () => import('./views/pif/EditPif.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/service/pif/:id',
      name: 'viewpif',
      component: () => import('./views/pif/ViewPif.vue'),
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/admins/:id',
      name: 'viewadmin',
      component: () => import('./views/admins/ViewAdmin.vue'),
      meta: {
        action: ['view admin'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/service/vtp/:id',
      name: 'viewvtp',
      component: () => import('./views/service/ViewVtp.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/service/functionality-raports',
      name: 'functionality-raports',
      component: () => import('./views/service/FunctionalityRaports.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/settings/service',
      name: 'servicesettings',
      component: () => import('./views/settings/ServiceSettings.vue'),
      meta: {
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/admins/:id/edit',
      name: 'editadmin',
      component: () => import('./views/admins/EditAdmin.vue'),
      meta: {
        action: ['update admin'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('./views/orders/Orders.vue'),
      meta: {
        action: ['view orders list'],
        requiresAuth: true
      }
    },
    {
      path: '/orders/create',
      name: 'createorder',
      component: () => import('./views/orders/CreateOrder.vue'),
      meta: {
        action: ['create order'],
        requiresAuth: true
      }
    },
    {
      path: '/orders/:id',
      name: 'vieworder',
      component: () => import('./views/orders/ViewOrder.vue'),
      meta: {
        action: ['view order'],
        requiresAuth: true
      }
    },
    {
      path: '/orders/:id/edit',
      name: 'editorder',
      component: () => import('./views/orders/EditOrder.vue'),
      meta: {
        action: ['update order'],
        requiresAuth: true
      }
    },
    {
      path: '/settings',
      name: 'viewsettings',
      component: () => import('./views/settings/ViewSettings.vue'),
      meta: {
        action: ['view global settings'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/settings/edit',
      name: 'editsettings',
      component: () => import('./views/settings/EditSettings.vue'),
      meta: {
        action: ['update global settings'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/roles',
      name: 'roles',
      component: () => import('./views/roles/Roles.vue'),
      meta: {
        action: [],
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/roles/create',
      name: 'createRole',
      component: () => import('./views/roles/CreateRole.vue'),
      meta: {
        action: [],
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/roles/:id',
      name: 'editrole',
      component: () => import('./views/roles/EditRole.vue'),
      meta: {
        action: [],
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/crm-section-settings',
      name: 'CrmSectionSettings',
      component: () => import('./views/crm-section-settings/CrmSectionSettings.vue'),
      meta: {
        action: ['view crm-settings'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/prizes',
      name: 'prizes',
      component: () => import('./views/prizes/Prizes.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/prizes/create',
      name: 'createprize',
      component: () => import('./views/prizes/AddPrize.vue'),
      meta: {
        action: ['view crm-settings'],
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/prizes/:id/edit',
      name: 'editprize',
      component: () => import('./views/prizes/EditPrize.vue'),
      meta: {
        action: ['update prize'],
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/prizes/settings',
      name: 'prizessettings',
      component: () => import('./views/prizes/PrizesSettings.vue'),
      meta: {
        action: ['view prize-settings'],
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/prizes/requests',
      name: 'prizesrequests',
      component: () => import('./views/requests/Requests.vue'),
      meta: {
        action: ['view prize-requests'],
        requiresAuth: true
      }
    },
    {
      path: '/invoices',
      name: 'invoices',
      component: () => import('./views/invoices/Invoices.vue'),
      meta: {
        action: ['view invoices list'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/invoices/create',
      name: 'createinvoices',
      component: () => import('./views/invoices/CreateInvoice.vue'),
      meta: {
        action: ['create invoice'],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/invoices/:id',
      name: 'viewinvoice',
      component: () => import('./views/invoices/ViewInvoice.vue'),
      meta: {
        action: [],
        requiresAuth: true
      }
    },
    {
      path: '/invoices/:id/edit',
      name: 'editinvoice',
      component: () => import('./views/invoices/EditInvoice.vue'),
      meta: {
        action: [],
        requiresAuth: true
      }
    },
    {
      path: '/invoices/:id/reverse',
      name: 'ReverseInvoice',
      component: () => import('./views/invoices/ReverseInvoice.vue'),
      meta: {
        action: [],
        requiresAuth: true,
        roles: []
      }
    },
    {
      path: '/product-search',
      name: 'productSearch',
      component: () => import('./views/ProductSearch.vue'),
      meta: {
        action: []
      }
    },
    {
      path: '/product-search-offer',
      name: 'productSearchOffer',
      component: () => import('./components/OfferProducts.vue'),
      meta: {
        action: []
      }
    }
  ]
})

router.afterEach((to, from) => {
  store.dispatch('showLoading')
  if (screen.width <= 850) {
    store.dispatch('toggleMenu')
  }
})

router.beforeEach((to, from, next) => {
  // check auth
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      // check permission
      if (to.matched.some(record => record.meta.action)) {
        if (to.meta.action.length === 0) {
          if (to.matched.some(record => record.meta.roles)) {
            if (to.meta.roles.length === 0 || (store.getters.user.roles.filter(value => to.meta.roles.includes(value)).length > 0)) {
              next()
              return
            }
            next('/login')
          }
          next()
          return
        }
        if (can(to.meta.action)) {
          next()
          return
        }
        next('/login')
      }
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

function can (permissionName) {
  let permissions = store.getters.user.permissions.filter(value => permissionName.includes(value))
  return (permissions.length > 0)
}

export default router
